<template>
  <div class="nav">
    <div class="item" v-for="item in navList" :key="item" @click="navClick(item)">
      <img :src="item.img_url" mode="widthFix" class="icon" />
      <div class="text">
        {{ item.title }}
      </div>
    </div>
  </div>
  <div class="pofid" id="experthead" style="" @click="downltop">
            <img src="https://www.fkhongdan.com/baiduxcx/downLoad.png" class="fknav1" />
        </div>
  <div class="tabs">
    <div
      class="item"
      :class="{ cur: select === item.lotteryClassCode }"
      @click="clickTab(item)"
      v-for="(item, index) in tabs"
      :key="index"
    >
      {{ item.title }}
    </div>
  </div>
  
  <div class="plan" v-for="(item,i) in planList['expertsPlanMap']" :key="i">
      <planCardSell :item="item" @click="gotoplanDetail(item)"></planCardSell>
      <Slider ref="slide" v-if="i===1"/>
  </div>
  <div class="fenge" @click="clickAll"></div>
  <!-- 更多 -->
    <div class="seeAll" @click="clickAll">
        查看全部
    </div>
    <div class="fenge" ></div>
    
</template>

<script>
import axios from "axios";
import Slider from '@/components/Slider';

import planCardSell from '@/components/plan-card-sell';
import { ref, inject, reactive, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
export default {
  name: "RJNewTuijian",
  components: {
    planCardSell,
    Slider
  },
  setup() {
    const baseurl =
      getCurrentInstance().appContext.config.globalProperties.axiosurlTow;
    let arr = [
      
      {
        skip_type: "11",
        img_url:
          "https://www.fkhongdan.com/images/hongdan/zqbf.png",
        title: "足彩比分",
      },
      {
        skip_type: "6",
        img_url:
          "http://file.fengkuangtiyu.cn/imagesCs/009/00916774619681917002.png",
        title: "大头指数",
      },
      // {
      //   skip_type: "7",
      //   img_url:
      //     "https://www.fkhongdan.com/baiduxcx/static/dataModel/icon_lqsj_hdxcx2.png",
      //   title: "篮球数据",
      // },
      {
        skip_type: "8",
        img_url:
          "http://file.fengkuangtiyu.cn/imagesCs/009/00916774620017142163.png",
        title: "差异分析",
      },
      {
        skip_type: "9",
        img_url:
          "http://file.fengkuangtiyu.cn/imagesCs/009/00916774620292538568.png",
        title: "冷门模型",
      },
      {
        skip_type: "10",
        img_url:
          "http://file.fengkuangtiyu.cn/imagesCs/009/00916774620503816746.png",
        title: "指数波动",
      },
    ];
    let tabsArr = [
      {
    "lotteryClassCode": "1002",
    "title": "推荐"
  },
  {
    "lotteryClassCode": "-201",
    "title": "竞足"
  },
  {
    "lotteryClassCode": "208",
    "title": "北单"
  },
  {
    "lotteryClassCode": "205",
    "title": "任九"
  },
  // {
  //   "lotteryClassCode": "1006",
  //   "title": "限免"
  // },
  
  {
    "lotteryClassCode": "1003",
    "title": "高命中"
  },
  {
    "lotteryClassCode": "1004",
    "title": "高回报"
  }

] 
// 总数据
    let planAll =reactive({dataBox:[]})
    let tabs = reactive(tabsArr)
    let navList = reactive(arr);
    const thislotid = inject('lottery').lotid
    let select = ref('');
    let planList =reactive({expertsPlanMap:[]})
    if(thislotid==='300'){
      select.value = '205'
    }else{
      select.value = '1002'
    }
    const getData = async () => {
      const { data } = await axios.get(
        `${baseurl}/api/homePage_36001800018.json`
      );
      planAll.dataBox=data.expertsPlanMap
      console.log(planAll.dataBox[select.value])
      if(planAll.dataBox[select.value][0]['dataList'].length>0){
        planList.expertsPlanMap=planAll.dataBox[select.value][0]['dataList']
      }else{
         planList.expertsPlanMap=planAll.dataBox[select.value][0]['extraMap']['historyList']
      }
    };
    const downltop = () => {
      window.parent.postMessage('xinrenClick','*')
    }
    const clickTab = (item) => {
      select.value = item.lotteryClassCode
      if(planAll.dataBox[select.value][0]['dataList'].length>0){
        planList.expertsPlanMap=planAll.dataBox[select.value][0]['dataList']
      }else{
         planList.expertsPlanMap=planAll.dataBox[select.value][0]['extraMap']['historyList']
      }
    }
    const navClick = (item) => {
      window.parent.postMessage('navClick'+item.skip_type,'*')
    }
    const clickAll = () => {
      window.parent.postMessage('ListClick'+select.value,'*')
    }
    const gotoplanDetail = (item) =>{
      window.parent.postMessage('plan'+item.erAgintOrderId,'*')
    }
    getData();
    return { navList, select, tabs, planList, planAll , navClick, clickTab, clickAll, gotoplanDetail, downltop};
  },
};
</script>

<style scoped="scoped">
*{
  box-sizing: border-box;
}
.fenge {
  height: 0.08rem;
  background-color: #f4f4f4;
}
.nav {
  border-top: 1px solid #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.12rem 0.12rem;
  background: #ffffff;
}

.nav .item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 0.5rem;
}
.nav .item:nth-child(5n) {
  margin-right: 0;
}
.nav .item .icon {
  width: 0.4rem;
  height: 0.4rem;
  object-fit: contain;
}
.nav .item .text {
  margin-top: 0.04rem;
  font-size: 0.12rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #101929;
  line-height: 0.17rem;
}
.tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 .15rem;
  height: .36rem;
  
}
.tabs .item.cur {
    position: relative;
    color: #f64646;
    
  }
  .cur::after {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      content: " ";
      width: .28rem;
      height: .02rem;
      background: #f64646;
      border-radius: .02rem;
    }
.tabs .item {
    font-size: 15px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: .36rem;
  }
  .seeAll{
                width: 100%;
                height: .44rem;
                background: #FFFFFF;
                border-radius: .06rem;
                font-size: .16rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #F64646;
                line-height: .44rem;
                text-align: center;
            }
  .pofid {
        width: 100%; 
    }
    .fknav1 {
        width: 100%;
        object-fit: contain;
    }
</style>
